import Table from 'partial/components/Table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import Badges from 'modules/common/components/Badge';
import Pagination from 'partial/components/Pagination';
import { formatNumber } from 'helper';
import { useOrgMaskNameList } from '../hooks';

function MaskNames() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useOrgMaskNameList(filter, orgUuid);

  const format = [
    { label: 'MASK NAME', key: 'name' },
    { label: 'AGENCY', key: 'organization_name' },
    { label: 'DATE APPROVED', key: 'approved_at' },
    { label: 'EXPIRY DATE', key: 'expired_at' },
    { label: 'REMARKS', key: 'remarks' },
    {
      id: 'sms_used',
      key: ({ sms_count, total_messages }) => (
        <span className="tabular-nums">
          {formatNumber(sms_count ?? total_messages ?? 0, 0)}
        </span>
      ),
      label: 'SMS USED',
      labelClassName: 'whitespace-nowrap flex justify-end',
      contentClassName: 'text-right',
    },
    {
      id: 'status',
      key: ({ status }) => <Badges status={status} />,
      labelClassName: 'whitespace-nowrap flex justify-center',
      contentClassName: 'px-[24px] md:!px-11 whitespace-nowrap text-right',
      label: 'STATUS',
    },
  ];

  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default MaskNames;
